var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRapoarte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_100",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.500854,
    y: 0.272949,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.50085 12.2729C9.21752 12.2729 8.98002 12.1771 8.78835 11.9854C8.59669 11.7938 8.50085 11.5563 8.50085 11.2729C8.50085 10.9896 8.59669 10.7521 8.78835 10.5604C8.98002 10.3688 9.21752 10.2729 9.50085 10.2729H15.5009C15.7842 10.2729 16.0217 10.3688 16.2134 10.5604C16.405 10.7521 16.5009 10.9896 16.5009 11.2729C16.5009 11.5563 16.405 11.7938 16.2134 11.9854C16.0217 12.1771 15.7842 12.2729 15.5009 12.2729H9.50085ZM9.50085 8.27295C9.21752 8.27295 8.98002 8.17712 8.78835 7.98545C8.59669 7.79378 8.50085 7.55628 8.50085 7.27295C8.50085 6.98962 8.59669 6.75212 8.78835 6.56045C8.98002 6.36878 9.21752 6.27295 9.50085 6.27295H15.5009C15.7842 6.27295 16.0217 6.36878 16.2134 6.56045C16.405 6.75212 16.5009 6.98962 16.5009 7.27295C16.5009 7.55628 16.405 7.79378 16.2134 7.98545C16.0217 8.17712 15.7842 8.27295 15.5009 8.27295H9.50085ZM6.50085 14.2729H14.0009C14.4842 14.2729 14.9342 14.3771 15.3509 14.5854C15.7675 14.7938 16.1175 15.0896 16.4009 15.4729L18.5009 18.2229V4.27295H6.50085V14.2729ZM6.50085 20.2729H17.5509L14.8259 16.6979C14.7259 16.5646 14.605 16.4604 14.4634 16.3854C14.3217 16.3104 14.1675 16.2729 14.0009 16.2729H6.50085V20.2729ZM18.5009 22.2729H6.50085C5.95085 22.2729 5.48002 22.0771 5.08835 21.6854C4.69669 21.2938 4.50085 20.8229 4.50085 20.2729V4.27295C4.50085 3.72295 4.69669 3.25212 5.08835 2.86045C5.48002 2.46878 5.95085 2.27295 6.50085 2.27295H18.5009C19.0509 2.27295 19.5217 2.46878 19.9134 2.86045C20.305 3.25212 20.5009 3.72295 20.5009 4.27295V20.2729C20.5009 20.8229 20.305 21.2938 19.9134 21.6854C19.5217 22.0771 19.0509 22.2729 18.5009 22.2729Z",
    fill: "#7E8488"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRapoarte);
export default __webpack_public_path__ + "static/media/icon_rapoarte.9f18d2139cb1e984d059ff9c83b25535.svg";
export { ForwardRef as ReactComponent };